<!-- The reorder gesture is disabled by default, enable it to drag and drop items -->
<ng-container *ngIf="!isLoading && template?.lineups.length; else addLineup">
    <ion-list-header color="light" class="content-width">
        <ion-label>{{ template.name }}</ion-label>
        <ion-spinner style="margin-right: 10px;" name="crescent" *ngIf="updatingLineup"></ion-spinner>
        <ion-icon style="margin-right: 10px;" *ngIf="showUpdateLineupCheckmark" color="success"
            name="checkmark"></ion-icon>

        <ion-button color="dark" (click)="removeLineup()">
            <ion-icon slot="icon-only" name="remove-circle"></ion-icon>
        </ion-button>
    </ion-list-header>

    <ng-container>
        <ion-list *ngFor="let cd of template.collectionDefinition; let i = index;" class="content-width">
            <ion-list-header>
                <ion-label>{{ cd.collectionName }}</ion-label>
                <ion-button (click)="addParticipant(cd, i)">
                    <ion-icon slot="icon-only" name="add"></ion-icon>
                </ion-button>
            </ion-list-header>

            <ion-reorder-group (ionItemReorder)="doReorder($event, i)" disabled="false">
                <ng-container
                    *ngIf="template.lineups[0]?.lineupCollectionDefinition[i]?.positionAssignments.length; else noParticipants">
                    <ion-item
                        *ngFor="let p of template.lineups[0].lineupCollectionDefinition[i].positionAssignments; let j = index">
                        <ion-label>
                            {{ j + 1 }}. {{ helper.getParticipantName(p.participant, 'full') }}
                            <p>{{ getSex(p?.participant?.person?.biographicalInformation?.sex) }}</p>
                        </ion-label>
                        <ion-reorder slot="start"></ion-reorder>
                        <ion-button slot="end" color="danger" (click)="removePosition(i, p.collectionPosition, j)"
                            fill="clear">
                            <ion-spinner
                                *ngIf="removingPosition && selectedPosition.collectionIndex === i && selectedPosition.positionAssignmentIndex === j; else removeIcon"
                                name="crescent"></ion-spinner>
                            <ion-icon
                                *ngIf="!(removingPosition && selectedPosition.collectionIndex === i && selectedPosition.positionAssignmentIndex === j)"
                                slot="icon-only" name="trash"></ion-icon>
                        </ion-button>
                    </ion-item>
                </ng-container>
            </ion-reorder-group>

        </ion-list>
        <div style="height: 30px"></div>
    </ng-container>
</ng-container>

<ng-template #noParticipants>
    <ion-item class="content-width">
        <ion-label>
            <ion-text color="medium">
                {{'No Participants' | translate}}
            </ion-text>
        </ion-label>
    </ion-item>
</ng-template>

<ng-template #addLineup>
    <app-empty-page *ngIf="!isLoading" text="{{'No lineup' | translate}}" iconName="people"></app-empty-page>
    <ion-button *ngIf="!isLoading" (click)="addTemp.chooseType()" expand="block" class="ion-padding content-width"
        style="margin-top: 50px">
        <span *ngIf="!addingLineup">{{'Add lineup' | translate}}</span>
        <ion-spinner *ngIf="addingLineup" name="crescent"></ion-spinner>
    </ion-button>
</ng-template>

<div *ngIf="isLoading" class="ion-padding content-width text-center">
    <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
</div>
<app-add-template hidden (selectedSubtype)="addTeamLineup($event)" #addTemp></app-add-template>